import { comparisonData } from '@/mocks/homeData';

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Why Use the <span className="text-primary-600">Basetao Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto">
            See how the Basetao Spreadsheet transforms your shopping experience compared to traditional methods.
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200">
          <table className="w-full">
            <thead>
              <tr className="bg-background-200/50">
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800">Feature</th>
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-600">
                  <span className="flex items-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-search-line text-foreground-400"></i>
                    </span>
                    Traditional Searching
                  </span>
                </th>
                <th className="text-left px-5 py-4 text-sm font-semibold text-primary-700">
                  <span className="flex items-center gap-2">
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-double-line text-primary-500"></i>
                    </span>
                    Basetao Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={row.feature} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="px-5 py-4 text-sm font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-4 text-sm text-foreground-600">{row.traditional}</td>
                  <td className="px-5 py-4 text-sm text-foreground-800">
                    <span className="flex items-center gap-2">
                      <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-primary-500 text-sm"></i>
                      </span>
                      {row.basetao}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}